module.exports = __webpack_public_path__ + "static/media/chantal-herrera.fcf6663c.jpg";